<h2 mat-dialog-title>Attention
  <mat-icon>warn</mat-icon>
</h2>

<mat-dialog-content>
  <p>{{message}} <em>{{value}}</em> ?</p>
</mat-dialog-content>

<mat-dialog-actions>
  <button mat-raised-button *ngIf='hasObservable'
          color='primary'
          [disabled]='loading$|async'
          (click)='closeRequest.emit(true)'
          cdkFocusInitial>Confirmer
  </button>
  <div *ngIf='!hasObservable || (loading$|async)'>
    <button mat-raised-button *ngIf='!hasObservable'
            color='primary'
            [mat-dialog-close]='true'
            cdkFocusInitial>Confirmer
    </button>
    <mat-spinner color='primary' [diameter]='20' *ngIf='loading$|async'></mat-spinner>
  </div>

  <button mat-raised-button *ngIf='hasObservable'
          color='accent'
          [disabled]='loading$|async'
          (click)='closeRequest.emit(false)'
          mat-dialog-close>Annuler
  </button>
  <button mat-raised-button *ngIf='!hasObservable'
          color='accent'
          mat-dialog-close>Annuler
  </button>
</mat-dialog-actions>
